// extracted by mini-css-extract-plugin
export var container = "_3q-0";
export var fullWidth = "_3q-3";
export var lined = "_3q-1";
export var selected = "_3q-4";
export var tab = "_3q-2";